import React, { useState } from 'react';
import { Box, Card, CardContent, Typography, } from '@mui/material';
import { AccountCircleOutlined, HighlightOff } from '@mui/icons-material';
import { formatDateTimeMonth } from '../../../../../../../../../utils/functions';
import { Pagination } from '@mui/material';
import { Alert, } from '../../../../../../../../../api/homeSiteAlerts/types';

interface DismissiedAlertsListProps {
    dimissedAlerts: Alert[];
    itemsPerPage: number;
}

const DismissiedAlertsList: React.FC<DismissiedAlertsListProps> = ({ dimissedAlerts, itemsPerPage }) => {
    const [page, setPage] = React.useState(1);
    const [activePage, setActivePage] = useState(1);

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
        setActivePage(value);
    };

    return (
        <Box>
            {dimissedAlerts.slice((activePage - 1) * itemsPerPage, activePage * itemsPerPage).map(alert => (
            <Card key={alert.id} variant="outlined" style={{ marginBottom: '8px', backgroundColor: '#FFFFFF', position: 'relative', border: "1.5px solid #FFE186" }}>
                <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6" sx={{
                    backgroundColor: "#C58026", // Background color
                    color: "white", // Text color
                    fontWeight: "bold", // Bold text
                    fontSize: "12px", // Font size
                    padding: "4px 12px", // Padding for the pill shape
                    borderRadius: "16px", // Rounded corners
                    marginBottom: "8px",
                    display: "inline-block", // Inline-block for text alignment
                    }}>{alert.mileStoneName}</Typography>
                    <HighlightOff sx={{ color: "#FFE186", marginLeft: "8px" }} />
                </Box>
                <Typography variant="body1" sx={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '14px' }}>{alert.alertName}</Typography>
                <Typography variant="body1" sx={{ fontSize: "14px", marginBottom: "8px" }}>{alert.description}</Typography>
                <Box display="flex" justifyContent="space-between" marginTop="8px">
                    <Box display="flex" alignItems="center">
                    <AccountCircleOutlined />
                    <Typography variant="caption" marginLeft="8px">
                        {alert.updatedBy}
                    </Typography>
                    </Box>
                    <Typography variant="caption">
                    {formatDateTimeMonth(alert.updatedOnDate)}
                    </Typography>
                </Box>
                </CardContent>
            </Card>
            ))}
            {dimissedAlerts.length > itemsPerPage && (
            <Box marginTop={2} display="flex" justifyContent="center">
                <Pagination
                count={Math.ceil(dimissedAlerts.length / itemsPerPage)}
                page={page}
                onChange={handleChange}
                />
            </Box>
            )}
        </Box>
    );
};

export default DismissiedAlertsList;
